import { useState, useRef, useEffect } from "react";
import useMeasure from "react-use-measure";
import styles from "./HeaderV3.module.scss";
import { ReactComponent as BoxOpened } from "../../assets/SVGs/chevron-down-white.svg";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";

const NavDrawer = ({ title, items }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [elementRef, bounds] = useMeasure();
  const wrapperRef = useRef(null);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    // Close if page changes
    setOpen(false);
    // Close if click outside
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    }, [location]);

  const toggleBox = () => {
    setOpen(!open);
  };

  const handleClick = () => {
    setOpen(false);
  };

  return (
    <motion.div 
      key={location.pathname}
      ref={wrapperRef}
      initial={{ backgroundColor: "rgba(36, 36, 36, 0)" }}
      animate={{ 
        height: bounds.height,  
        backgroundColor: open ? "rgba(36, 36, 36, 1)" : "rgba(36, 36, 36, 0)" 
      }}
      transition={{ duration: 0.2 }}
      className={`${styles.drawerContainer}`}
    >
      <div style={{ width: "100%" }} ref={elementRef}>
          <div
            className={`${styles.title} ${open ? styles.open : styles.closed}`}
            onClick={toggleBox}
          >
            <p>{title}</p>
            <BoxOpened className={styles.arrow} />
          </div>
          <AnimatePresence>
            {open && (
              <motion.div
                className={styles.drawer}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.05 }}
              >
                {items.map((item, i) => (
                  <Link
                    to={item.to}
                    key={i}
                    className={`${styles.navLink}`}
                    onClick={handleClick}
                  >
                    <p>{item.title}</p>
                  </Link>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default NavDrawer;

